import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

let cachedValidHotels = null;
let cachedHotelData = null;
let cacheTime = null;
const CACHE_DURATION = 60 * 60 * 1000; // 60 minutes

export const getValidHotels = async () => {
    // Return cached data if still valid
    if (cachedValidHotels && cacheTime && (Date.now() - cacheTime < CACHE_DURATION)) {
        return cachedValidHotels;
    }

    try {
        const hotelsCollectionRef = collection(db, 'hotels');
        const querySnapshot = await getDocs(hotelsCollectionRef);

        const validHotels = new Set();
        const hotelData = {};
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            validHotels.add(doc.id);
            hotelData[doc.id] = {
                id: doc.id,
                displayName: data.displayName || doc.id
            };
        });

        // Cache the results
        cachedValidHotels = validHotels;
        cachedHotelData = hotelData;
        cacheTime = Date.now();

        return validHotels;
    } catch (error) {
        console.error('Error fetching valid hotels:', error);
        throw error;
    }
};

export const getHotelData = async () => {
    // Ensure hotels are loaded
    await getValidHotels();
    return cachedHotelData || {};
};

export const getHotelDisplayName = async (hotelId) => {
    try {
        const hotelData = await getHotelData();
        return hotelData[hotelId]?.displayName || hotelId;
    } catch (error) {
        console.error('Error getting hotel display name:', error);
        return hotelId; // Fallback to hotel ID
    }
};

export const isValidHotel = async (hotelId) => {
    try {
        const validHotels = await getValidHotels();
        return validHotels.has(hotelId);
    } catch (error) {
        console.error('Error validating hotel ID:', error);
        // In case of error, allow access but log the issue
        return true;
    }
};

export const clearHotelCache = () => {
    cachedValidHotels = null;
    cachedHotelData = null;
    cacheTime = null;
}; 